import React, { useState } from 'react'
import HubDetailForm from './HubDetailForm'
import HubDetailList from './HubDetailList'

const HubDetail= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <HubDetailForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <HubDetailList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default HubDetail